export default __webpack_public_path__ + "static/partners-hero-16d891f80d73f57d80163b463249acb0.jpg";